import { API_V1 } from 'API/APIs/APIv1';
import { AxiosResponse } from 'axios';
import i18n from 'i18n';
import _ from 'lodash';
import Logger from 'logger';

export const createHrProject = async (occupationId: string, userQuery?: string): Promise<AxiosResponse<any, any>['data']> => {
  try {
    const response = await API_V1.post('/projects/hr', {
      occupationId,
      userQuery,
    });

    return {
      data: response.data,
    };
  } catch (e) {
    Logger.trace('Error while creating hr project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getHrProjectByOccupation = async (occupationId: string): Promise<AxiosResponse<any, any>['data']> => {
  try {
    const response = await API_V1.get('/projects/hr/by-occupation', {
      params: { occupationId },
    });

    return {
      data: response.data,
    };
  } catch (e) {
    Logger.trace('Error while creating hr project!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getAllHrProjects = async (searchParam?: string, limit?: number, offset?: number) => {
  try {
    const params: any = {};
    if (!_.isNil(searchParam) && searchParam !== '') {
      params.q = searchParam;
    }
    if (!_.isNil(limit)) {
      params.limit = limit;
    }
    if (!_.isNil(offset)) {
      params.offset = offset;
    }
    const response = await API_V1.get('/projects/hr', { params });

    return {
      data: response.data,
    };
  } catch (e) {
    Logger.trace('Error while getting occupation analysis!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const getHrProjectAnalysis = async (projectId: string): Promise<AxiosResponse<any, any>['data']> => {
  try {
    const languageOptions = i18n.languages[0] || localStorage.getItem('i18nextLng');
    const language = languageOptions!.split('-')[0];

    const response = await API_V1.get(`/projects/hr/${projectId}`, {
      params: { lang: language },
    });

    return {
      data: response.data,
    };
  } catch (e) {
    Logger.trace('Error while getting occupation analysis!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};
